<template>
    <div id="card">
      <div class="nav-card">
        <div class="nav-header">
          <ul class="nav-bar">
            <li v-for="(item,index) in topBarList" :key="index">
              <router-link :class="[$route.path.indexOf(item.key)!==-1?'link-active':'']" :to="item.url" :replace="index>1?true:''">{{item.title}}</router-link>
            </li>
          </ul>
          <ul class="nav-link">
            <li>
              <router-link :to="{path:languageTypeUrl,query:{navIndex:0}}">首页</router-link>
            </li>
            <li v-if="$route.matched[1]">
              &gt;
              <router-link :to="$route.matched[1].path">{{$route.matched[1].meta.title}}</router-link>
            </li>
            <li v-if="$route.matched.length > 2">
              &gt;
              <router-link :to="$route.matched[2].path">{{$route.matched[2].meta.title}}</router-link>
            </li>
          </ul>
        </div>
        <div class="nav-body">
          <router-view></router-view>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    name: 'appointment',
    data () {
        return {
            languageTypeUrl: ''
        }
    },
    props: {
        topBarList: {
            type: Array,
            default () {
                return []
            }
        }
    },
    mounted () {
        if (localStorage.languageType && (localStorage.languageType !== 'undefined')) {
            this.languageTypeUrl = '/' + localStorage.languageType + '/index'
        } else {
            this.languageTypeUrl = '/zh-CN/index'
        }
    }
}
</script>
<style lang="scss" scoped>
	#card {
		.nav-card {
			max-width: 1200px;
			position: relative;
			margin: -60px auto 100px;
			.nav-header {
				width: 100%;
				box-sizing: border-box;
				ul.nav-link {
					height: 16px;
					line-height: 16px;
					margin: 30px 0 20px 0;
					font-size: 16px;
					li {
						display: inline;
						color: #6C6A66;
						a {
							color: inherit;
						}
						&:last-child>a {
							color: #AD011B;
						}
					}
				}
				ul.nav-bar {
					text-align: center;
					li {
						display: inline-block;
						width: 270px;
						height: 60px;
						text-align: center;
						height: 60px;
						line-height: 60px;
						&:hover a{
							color: #fff;
							background-color: #edaa42;
						}
						&:nth-of-type(2) {
							border-left: 1px solid #e9e9e9;
							border-right: 1px solid #e9e9e9;
						}
						>a {
							background: rgba(255, 255, 255, .7);
							display: block;
							width: auto;
							height: 100%;
							text-align: center;
							color: #323232;
							font-size: 20px;
							&.link-active {
								color: #fff;
								background: rgba(237, 170, 66, 0.9);
							}
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/cardtwo.vue